import { useQuery } from "react-query";
import { IeLynxObject } from "../../common/models/eLynxObject";
import AttachmentsDataService from "../../services/attachments-data-service/AttachmentsDataService";
import { IObjectAttachmentsModel } from "../../services/attachments-data-service/Models";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseObjectAttachmentsQueryParams = {
    groupID: number,
    eLynxObject: IeLynxObject
} & BaseUseQueryParameters<IObjectAttachmentsModel>;

export function useAttachments(params: UseObjectAttachmentsQueryParams) {
    return useQuery<IObjectAttachmentsModel, RestError>(
        keys.attachments(params.groupID, params.eLynxObject),
        ({ signal }) => {
            return AttachmentsDataService.getAttachments(params.groupID, params.eLynxObject, signal);
        },
        {
            onError: params.onError,
            onSuccess: params.onSuccess,
            refetchInterval: params.refreshSeconds ? params.refreshSeconds * 1000 : false
        }
    );
}
